define(
    'viewmodels/secured/libraries/create/fromScratch/list/list',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings",

        "viewmodels/secured/libraries/create/fromScratch/confirm/confirm"
    ],
    function (
        ViewModel,
        dataProvider,
        i19n,

        step4

        ){

        var comboBox = null;

        var vm = new ViewModel(
        {
            id: '',
            i19n: i19n,

            step4: step4,

            listId: ko.observable(),
            listOption: ko.observable('list'),
            list: function () {
                if (comboBox == null)
                    return '';

                if (comboBox.text() == i19n.to.selectalist)
                    return i19n.to.nolist;

                return comboBox.text();
            }
        });

        vm.activate = function () {
            var self = this;

            self.listId(null);
            self.listOption('list');
        };
        vm.attached = function () {
            var self = this;

            comboBox = $("#list_fromScratch").kendoDropDownList({
                dataTextField: "text",
                dataValueField: "value",
                optionLabel: i19n.to.selectalist,
                dataSource: {
                    transport: {
                        read: function (callbacks) {
                            dataProvider.lists
                            .getLists()
                            .done(function (data) {
                                var list = _.map(data, function (itm) {
                                    return { value: itm.listId, text: itm.name };
                                });
                                callbacks.success(list);
                            })
                            .fail(function () {
                                console.log('error loading list');
                            });
                        },
                    }
                }
            }).data("kendoDropDownList");
        };
        vm.validate = function () {
            if (vm.listOption() == 'list') {
                $("#list_fromScratch").attr("required", "true");
            } else {
                $("#list_fromScratch").removeAttr("required");
            }

            var validator = $("#wizard-fromscratch-list").kendoValidator().data("kendoValidator");

            if (validator.validate()) {
                vm.step4.listId(vm.listOption() == "list" ? vm.listId() : '');

                if (vm.listOption() == "list")
                    vm.step4.list(vm.list());

                if (vm.listOption() == "folders")
                    vm.step4.list(i19n.to.thelibrarywilluseonly);

            } else {
                return false;
            }

            return true;
        };

        return vm;
    }
);
